import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/console/dashboard')({
  staticData: {
    privileges: ['0.1'],
  },
})
